import Authorizor from '@/util/authorizor';

export interface SessionKeySearchParams {
    key?: string;
}

export const saveAppState = (key: string) => {
    Authorizor.saveState(key);
}

export const restoreAppState = (key: string, clear: boolean = true) => {
    Authorizor.restoreState(key, clear);
}
